<script setup>
import CountryList from "../include/CountryList";
import UserService from "../services/UserService";
import i18n from "../i18n/i18n";
import {BForm, BFormGroup, BFormInput, BFormSelect, BFormInvalidFeedback} from 'bootstrap-vue-next';
import {ref, watch, reactive} from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps({
    modelValue: Object
});

const emit = defineEmits(['update:modelValue', 'registrationSuccessful']);

const user = reactive({country_code: 'DE'});
const captcha_state = ref(null);
const formRegister = ref(null);

watch(user, (newValue) => {
    emit('update:modelValue', newValue);
}, {deep: true});

function submit() {
    // b-form is a component, not a DOM node — it exposes the native <form> as `element`.
    const formElement = formRegister.value?.element ?? formRegister.value?.$el;

    if (formElement?.reportValidity()) {
        UserService.register(user).then(() => {
            alert(i18n.global.t('Registration successful. Your registration data will be checked and you will be notified when your account is ready.'));
            emit('registrationSuccessful');
        }).catch(error => {
            captcha_state.value = error.response.data.message !== 'Captcha value is invalid';
        });
    }
}

defineExpose({submit});
</script>

<template>
    <b-form ref="formRegister">
        <b-form-group :label="t('E-mail Address')" label-cols="3">
            <b-form-input v-model="user.email_address" required/>
        </b-form-group>
        <b-form-group :label="t('Password')" label-cols="3">
            <b-form-input type="password" v-model="user.password" required/>
        </b-form-group>
        <b-form-group :label="t('Confirm password')" label-cols="3">
            <b-form-input type="password" v-model="user.password_confirm" required/>
        </b-form-group>
        <b-form-group :label="t('Customer number')" label-cols="3">
            <b-form-input v-model="user.customer_number"/>
        </b-form-group>
        <b-form-group :label="t('Company')" label-cols="3">
            <b-form-input v-model="user.company" required/>
        </b-form-group>
        <b-form-group :label="t('First Name')" label-cols="3">
            <b-form-input v-model="user.first_name" required/>
        </b-form-group>
        <b-form-group :label="t('Last Name')" label-cols="3">
            <b-form-input v-model="user.last_name" required/>
        </b-form-group>
        <b-form-group :label="t('Address')" label-cols="3">
            <b-form-input v-model="user.address"/>
        </b-form-group>
        <b-form-group :label="t('Zip Code')" label-cols="3">
            <b-form-input v-model="user.zip_code"/>
        </b-form-group>
        <b-form-group :label="t('City')" label-cols="3">
            <b-form-input v-model="user.city"/>
        </b-form-group>
        <b-form-group :label="t('Country')" label-cols="3">
            <b-form-select v-model="user.country_code" :options="CountryList" text-field="name" value-field="code"
                           required/>
        </b-form-group>
        <b-form-group :label="t('Phone number')" label-cols="3">
            <b-form-input v-model="user.phone_number"/>
        </b-form-group>
        <b-form-group :label="t('Mobile number')" label-cols="3">
            <b-form-input v-model="user.mobile_number"/>
        </b-form-group>
        <b-form-group :label="t('Captcha')" label-cols="3">
            <div class="row">
                <div class="col">
                    <span
                        class="text-muted">{{ t('Type in the result of the following calculation. This will help to protect us from spam bots.') }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-auto"><img alt="Captcha" :src="UserService.registerCaptchaUri()"></div>
                <div class="col">
                    <b-form-input v-model="user.captcha_result" :state="captcha_state" required/>
                    <b-form-invalid-feedback>
                        {{ t('This value is invalid.') }}
                    </b-form-invalid-feedback>
                </div>
            </div>
        </b-form-group>
    </b-form>
</template>


<style scoped>

</style>
